/**
 * OrbDocCoreConceptsTraitsENDocEx2StatusView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsTraitsENDocEx2Status
 */

import { useOrbDocCoreConceptsTraitsENDocEx2StatusLogic } from '@/hooks/traits/useOrbDocCoreConceptsTraitsENDocEx2StatusLogic';
import type { OrbDocCoreConceptsTraitsENDocEx2StatusConfig } from '@/hooks/traits/useOrbDocCoreConceptsTraitsENDocEx2StatusLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsTraitsENThermostat } from '@app/shared';
import { Badge } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsTraitsENDocEx2StatusViewProps {
  config?: Partial<OrbDocCoreConceptsTraitsENDocEx2StatusConfig>;
}

export function OrbDocCoreConceptsTraitsENDocEx2StatusView({ config: propsConfig }: OrbDocCoreConceptsTraitsENDocEx2StatusViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsTraitsENDocEx2StatusLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsTraitsENThermostat'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsTraitsEN" trait="OrbDocCoreConceptsTraitsENDocEx2Status">
      {slotWriter['main'] === 'INIT' ? (<Typography content="Set a temperature between 16 and 28 °C." variant="body" color="muted" />) : slotWriter['main'] === 'SHOW' ? (<Badge label={((((+(lastPayload?.target ?? 0) > 23) ? "Heating up" : ((+(lastPayload?.target ?? 0) < 19) ? "Cooling down" : "Comfortable"))) as string | number | undefined)} variant={(((+(lastPayload?.target ?? 0) > 23) ? "warning" : ((+(lastPayload?.target ?? 0) < 19) ? "info" : "success")) as 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'error' | 'info' | 'neutral')} />) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsTraitsENDocEx2StatusView;
